import style from "./element-data-editor.module.css";
import DataEditorIntegrationItem from "./integration-item/data-editor-integration-item";
import DataEditorIntegrationItemSkeleton from "./integration-item/data-editor-integration-item-skeleton";
import { useDynamicIntegrations } from "../../hooks/use-dynamic-integrations";
import { CanvasElement } from "shared/datamodel/schemas";

interface ElementDataEditorProps {
  elementId: string;
  element: CanvasElement;
}

function ElementDataEditor({ elementId, element }: ElementDataEditorProps) {
  const { isLoading, integrationItemIds, integrationsConfig } = useDynamicIntegrations(elementId, element);

  const integrationIds = Object.entries(integrationItemIds);

  function renderIntegration(integrationId: string, itemIds: string[]) {
    const integration = integrationsConfig[integrationId];

    if (isLoading) {
      return itemIds.map((itemId) => <DataEditorIntegrationItemSkeleton key={`skeleton-${itemId}`} />);
    }

    const missingItems = new Set(
      itemIds.filter((itemId) => !integration?.data?.items?.some((item: { id: string }) => item.id === itemId))
    );

    return itemIds.map((itemId, index) => (
      <DataEditorIntegrationItem
        key={itemId}
        elementId={elementId}
        element={element}
        integrationId={integrationId}
        itemId={itemId}
        columns={integration?.columns ?? []}
        startExpanded={index === itemIds.length - 1 && missingItems.size === 0}
        isMissing={missingItems.has(itemId)}
      />
    ));
  }

  return (
    <div className={style.container}>
      <div className={style.header}>
        <span className={style.title}>Display data on your shape </span>
        <span className={style.description}>Select monday items to display on the shape.</span>
      </div>
      <div className={style.contentWrapper}>
        <div className={style.headerGradient} />
        <div className={style.contentContainer}>
          {integrationIds.map(([integrationId, itemIds]) => renderIntegration(integrationId, itemIds))}
        </div>
        <div className={style.footerGradient} />
      </div>
    </div>
  );
}

export default ElementDataEditor;
